// Hands a CSV the console generated to the browser as a download. Nothing is sent anywhere: sending an export to a
// third party (for example NDC support) stays a deliberate human step.
export function downloadCsv(filename: string, csv: string) {
  const blob = new Blob([csv], { type: "text/csv" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
